import React, { memo } from 'react';

import { makeStyles } from '@mui/styles';
import SvgIcon from '@mui/material/SvgIcon';

const useStyles = makeStyles({
  icon: {
    width: '1.5rem',
    height: '1.5rem',
  },
});

const ListMinifiedIcon = () => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon} fill="white">
      <path d="M0 0H24V4H0V0Z" />
      <path d="M0 6.5H24V10.5H0V6.5Z" />
      <path d="M0 13.5H24V17.5H0V13.5Z" />
      <path d="M0 20H24V24H0V20Z" />
    </SvgIcon>
  );
};

export default memo(ListMinifiedIcon);
